import { render } from "./CardVue.vue?vue&type=template&id=b7c060de&scoped=true"
import script from "./CardVue.vue?vue&type=script&lang=js"
export * from "./CardVue.vue?vue&type=script&lang=js"

import "./CardVue.vue?vue&type=style&index=0&id=b7c060de&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7c060de"]])

export default __exports__